import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ISearchValue } from '@interfaces/common/store';

interface IInitialState {
	searchValue: string;
	milestones: string[] | null;
}

const initialState: IInitialState = {
	searchValue: '',
	milestones: null,
};

const portalFolders = createSlice({
	name: 'portalFolders',
	initialState,
	reducers: {
		setSearchValue: (state, action: PayloadAction<ISearchValue>) => {
			state.searchValue = action.payload.searchValue;
		},
		setMilestones: (state, action: PayloadAction<{ milestones: string[] | null }>) => {
			state.milestones = action.payload.milestones;
		},
		resetPortalFolders: () => initialState,
	},
});

export const {
	setSearchValue,
	resetPortalFolders,
	setMilestones,
} = portalFolders.actions;

export default portalFolders.reducer;
